import { lazy } from 'react';

const FilmsPageAsync = lazy(() => import('./FilmsPage'));

export default FilmsPageAsync;
